// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"290":"ed225442","418":"8aaa5f05","743":"73d93716"}[chunkId] + ".js";
};